class AuthService {
    constructor() {
        this.stateManager = window.AppState;
        this.initAuthListeners();

        this.userId = null;

        // this.unsubscribe = this.stateManager.subscribe((state) => {
        //     if (state.auth.user && document.getElementById('auth-page')) {
        //         this.redirectToApp();
        //     }

        //     if (!state.auth.user && document.getElementById('auth-page')) {
        //         this.redirectToAuth();
        //     }
        // });
    }

    initAuthListeners() {
        document.getElementById('login-form').addEventListener('submit', async (e) => {
            e.preventDefault();

            await this.handleLogin();
        });

        document.getElementById('pin-form').addEventListener('submit', async (e) => {
            e.preventDefault();
            await this.handlePin();
        });
    }

    /**
     * Обработчик формы логина
     */
    async handleLogin() {
        const email = document.getElementById('email').value;
        const btn = document.getElementById('login-btn');

        try {
            btn.disabled = true;

            const response = await window.ajax.post('/user/request-pin', { email });
            btn.disabled = false;
            window.__log('handleLogin response', response);

            if (response.error === 1) return window.__notify.errorNotify(response.message);

            this.userId = response.userId;
            this.openPinPage();
        } catch (err) {
            window.__notify.errorNotify(window.custErrors.TEHNICAL);
            btn.disabled = false;
        }
    }

    /**
     * Обработчик формы отправки pin кода
     */
    async handlePin() {
        const pin = document.getElementById('pin').value;
        const btn = document.getElementById('pin-btn');

        try {
            btn.disabled = true;

            const response = await window.ajax.post('/user/verify-pin', { userId: this.userId, pin });
            btn.disabled = false;
            window.__log('handlePin response', response);

            if (response.error === 1) return window.__notify.errorNotify(response.message);

            localStorage.setItem('authToken', response.token);
            window.__log('authToken', response);

            await this.updateUserState();
            this.redirectToApp();
        } catch (err) {
            btn.disabled = false;
            window.__notify.errorNotify(window.custErrors.TEHNICAL);
        }
    }

    openPinPage() {
        document.getElementById('login-form').classList.add('hidden');
        document.getElementById('pin-form').classList.remove('hidden');
    }

    redirectToApp() {
        window.__log('redirectToApp');
        document.getElementById('auth-page').classList.add('hidden');
        document.getElementById('app-content').classList.remove('hidden');

        // Обновляем интерфейс для авторизованного пользователя
        this.updateUIForLoggedInUser();
    }

    redirectToAuth() {
        window.__log('redirectToAuth');
        document.getElementById('auth-page').classList.remove('hidden');
        document.getElementById('app-content').classList.add('hidden');
    }

    updateUIForLoggedInUser() {
        const userElement = document.querySelector('.user-name');
        const emailElement = document.querySelector('.user-email');
        const avatarElement = document.querySelector('.avatar');

        if (userElement && emailElement && avatarElement) {
            userElement.textContent = this.currentUser.name || 'Пользователь';
            emailElement.textContent = this.currentUser.email;
            avatarElement.textContent = this.currentUser.name.charAt(0).toUpperCase();
        }
    }

    clearErrors() {
        document.querySelectorAll('.error-message').forEach(el => {
            el.style.display = 'none';
        });
    }

    isAuth() {
        const token = localStorage.getItem('authToken');
        return !!token;
    }

    async updateUserState(updateState = true) {
        const response = await window.ajax.get(`/user/info/me`);

        window.__log('updateUserState response', response);

        if (response.error === 1) throw new Error(response.message);
        if (!response.user) throw new Error('Not user');

        if (updateState) {
            this.stateManager.updateState(state => ({
                auth: {
                    ...state.auth,
                    user: response.user,
                    isLoading: false,
                    error: null
                }
            }));
        }

        return response.user;
    }

    signOut() {
        window.__log('signOut');
        localStorage.removeItem('authToken');
        this.stateManager.updateState(state => ({
            auth: {
                ...state.auth,
                user: null
            }
        }));
    }
}

window.authService = new AuthService();